import { ADMIN_BOSCH, ADMIN, MANAGER } from "../../Constantes/userRoles";

export const ROUTE_PANEL = "/";
export const ROUTE_CASES = "/cases";
export const ROUTE_WORKSHOPS = "/workshops";
export const ROUTE_VEHICLE = "/Vehicles";
export const ROUTE_CLIENTS = "/clients";
export const ROUTE_ITVS = "/itv";
export const ROUTE_LOGIN= "/login";
export const ROUTE_DASHBOARD = "/dashboard"
export const ROUTE_CAMPAIGN_STATISTICS = "/campaigns"
export const ROUTE_BRANDS = "/brands"
export const ROUTE_MODELS = "/models"

export const ROUTE_ADMINS_MENU = "/admin";
export const ROUTE_STATES = "/admin/states";
export const ROUTE_TAXONOMIES = "/admin/taxonomies";
export const ROUTE_ENTRY_CHANNEL = "/admin/entrychannel";
export const ROUTE_INTERACTION = "/admin/interaction";
export const ROUTE_USERS = "/admin/users"
export const ROUTE_EXCEPTIONS = "/admin/exceptions"
export const ROUTE_SUBSTATES = "/admin/subStates"
export const ROUTE_CONTRACT_DATA = "/admin/contractData"
export const ROUTE_TEMPLATES = "/admin/templates"
export const ROUTE_EXTERNAL_USERS = "/admin/externalUsers"
export const ROUTE_ADMIN_WORKSHOPS = "/admin/workshops"
export const ROUTE_ADMIN_FILE_MANAGEMENT = "/admin/fileManagement"
export const ROUTE_ADMIN_CAMPAIGN = "/admin/campaigns"
export const ROUTE_MAIL_MAPPERS = "/admin/mailMappers"
export const ROUTE_ADMIN_BRANDS = "/admin/brands"
export const ROUTE_ADMIN_MODELS = "/admin/models"

export const routeList = [
        {path: ROUTE_DASHBOARD, label: "Dashboard", allowedRoles: [ADMIN, MANAGER]}, 
        {path: ROUTE_PANEL, label: "Painel", allowedRoles: ["*"]}, 
        {path: ROUTE_CASES, label: "Chamados", allowedRoles: ["*"]},
        // {path: ROUTE_CAMPAIGN_STATISTICS, label: "Campañas", allowedRoles: [MANAGER, ADMIN]}, 
        // {path: ROUTE_WORKSHOPS, label: "Talleres",  allowedRoles: ["*"]}, 
        {path: ROUTE_CLIENTS, label: "Clientes", allowedRoles: ["*"]},
        {path: ROUTE_BRANDS, label: "Montadoras", allowedRoles: ["*"]},
        {path: ROUTE_MODELS, label: "Modelos", allowedRoles: ["*"]}, 
        // {path: ROUTE_VEHICLE, label: "Veículos", allowedRoles: ["*"]}, 
        // {path: ROUTE_ITVS, label: "ITV", allowedRoles: ["*"]}
        
];